<template>
  <span class="plan-item-info">
    <i class="bi bi-info-circle plan-item-info__icon" aria-label="Más información"></i>
    <div class="plan-item-info__bubble">{{ text }}</div>
  </span>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'PlanItemInfoIcon',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
});
</script>

<style scoped>
.plan-item-info {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.plan-item-info__icon {
  color: #75b846;
  font-size: 18px;
  cursor: default;
}

.plan-item-info__bubble {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #1e1e2d;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: normal;
  min-width: 160px;
  max-width: 260px;
  z-index: 20;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
}

.plan-item-info:hover .plan-item-info__bubble {
  opacity: 1;
  visibility: visible;
}

.plan-item-info__bubble::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1e1e2d;
}
</style>
